import { render, staticRenderFns } from "./CampaignStatsDataTable.vue?vue&type=template&id=7c708ae7&"
import script from "./CampaignStatsDataTable.vue?vue&type=script&lang=js&"
export * from "./CampaignStatsDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports